/**
 * Köttbutiken: innehållsförteckningen i recept och guider (snippets/kb-artikel-toc.liquid).
 * Markerar avsnittet man läser med aria-current, i alla förteckningar på sidan (sidospalten och mobilens),
 * förebild niemibil.se. Ett avsnitt räknas som aktuellt när dess överkant passerat headern.
 * Lyssnar på scroll i fångstfasen, eftersom sidan kan scrolla i ett annat element än fönstret.
 */
class KbArtikelToc extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('a[href^="#"]').forEach((lank) => {
      lank.addEventListener('click', () => {
        markera(lank.getAttribute('href')?.slice(1) ?? '');
        this.querySelector('details')?.removeAttribute('open');
      });
    });
    starta();
  }
}

/** @type {HTMLElement[]} */
let avsnitt = [];
let aktuellt = '';
let startad = false;
let vantar = false;

function lankar() {
  return /** @type {HTMLAnchorElement[]} */ ([...document.querySelectorAll('kb-artikel-toc a[href^="#"]')]);
}

/** @param {string} id */
function markera(id) {
  if (id === aktuellt) return;
  aktuellt = id;
  for (const lank of lankar()) {
    if (lank.getAttribute('href') === `#${id}`) lank.setAttribute('aria-current', 'true');
    else lank.removeAttribute('aria-current');
  }
}

function uppdatera() {
  vantar = false;
  if (!avsnitt.length) return;
  let traff = avsnitt[0];
  for (const el of avsnitt) {
    const marginal = parseFloat(getComputedStyle(el).scrollMarginTop) || 0;
    if (el.getBoundingClientRect().top <= marginal + 40) traff = el;
  }
  // Längst ned på sidan: sista avsnittet, även om det är för kort för att nå upp
  const rot = scrollbehallare(avsnitt[0]);
  if (rot.scrollHeight > rot.clientHeight && rot.scrollTop + rot.clientHeight >= rot.scrollHeight - 2) {
    const sista = avsnitt[avsnitt.length - 1];
    if (sista && sista.getBoundingClientRect().top < window.innerHeight) traff = sista;
  }
  if (traff) markera(traff.id);
}

/**
 * Elementet som sidan scrollar i (Horizon scrollar ibland i ett inre element i stället för fönstret).
 * @param {HTMLElement | undefined} el
 */
function scrollbehallare(el) {
  for (let f = el?.parentElement; f && f !== document.body; f = f.parentElement) {
    const overflow = getComputedStyle(f).overflowY;
    if ((overflow === 'auto' || overflow === 'scroll') && f.scrollHeight > f.clientHeight) return f;
  }
  return document.scrollingElement ?? document.documentElement;
}

function begar() {
  if (vantar) return;
  vantar = true;
  requestAnimationFrame(uppdatera);
}

function starta() {
  const ids = [...new Set(lankar().map((lank) => lank.getAttribute('href')?.slice(1) ?? ''))];
  avsnitt = ids.map((id) => document.getElementById(id)).filter((el) => el instanceof HTMLElement);
  if (startad) return begar();
  startad = true;
  document.addEventListener('scroll', begar, { capture: true, passive: true });
  window.addEventListener('resize', begar);
  begar();
}

if (!customElements.get('kb-artikel-toc')) customElements.define('kb-artikel-toc', KbArtikelToc);
